import * as u from "react";
import { useState as We } from "react";
import { d as ne, c as Be, b as _, a as Ue } from "./index-Dn5fq5RO.js";
import { u as Q } from "./index-BwdHfdWj.js";
import { c as pe, A as he, D as He, C as Ke, a as je, R as Ve, P as Xe } from "./index-DpS21AEH.js";
import { P as J } from "./index-Bo0P2KXg.js";
import { jsx as E } from "react/jsx-runtime";
import { u as Ye } from "./index-_igB3qdS.js";
import { P as me } from "./index-C7ixzbBF.js";
import { S as Ge } from "./index-DK6lfaz2.js";
var V = 0;
function Ze() {
  u.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? oe()), document.body.insertAdjacentElement("beforeend", e[1] ?? oe()), V++, () => {
      V === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), V--;
    };
  }, []);
}
function oe() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var X = "focusScope.autoFocusOnMount", Y = "focusScope.autoFocusOnUnmount", ae = { bubbles: !1, cancelable: !0 }, ze = "FocusScope", ge = u.forwardRef((e, t) => {
  const {
    loop: r = !1,
    trapped: n = !1,
    onMountAutoFocus: a,
    onUnmountAutoFocus: c,
    ...s
  } = e, [o, g] = u.useState(null), v = ne(a), m = ne(c), l = u.useRef(null), d = Q(t, (i) => g(i)), h = u.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  u.useEffect(() => {
    if (n) {
      let i = function(y) {
        if (h.paused || !o) return;
        const b = y.target;
        o.contains(b) ? l.current = b : R(l.current, { select: !0 });
      }, f = function(y) {
        if (h.paused || !o) return;
        const b = y.relatedTarget;
        b !== null && (o.contains(b) || R(l.current, { select: !0 }));
      }, p = function(y) {
        if (document.activeElement === document.body)
          for (const C of y)
            C.removedNodes.length > 0 && R(o);
      };
      document.addEventListener("focusin", i), document.addEventListener("focusout", f);
      const S = new MutationObserver(p);
      return o && S.observe(o, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", i), document.removeEventListener("focusout", f), S.disconnect();
      };
    }
  }, [n, o, h.paused]), u.useEffect(() => {
    if (o) {
      ue.add(h);
      const i = document.activeElement;
      if (!o.contains(i)) {
        const p = new CustomEvent(X, ae);
        o.addEventListener(X, v), o.dispatchEvent(p), p.defaultPrevented || ($e(tt(ye(o)), { select: !0 }), document.activeElement === i && R(o));
      }
      return () => {
        o.removeEventListener(X, v), setTimeout(() => {
          const p = new CustomEvent(Y, ae);
          o.addEventListener(Y, m), o.dispatchEvent(p), p.defaultPrevented || R(i ?? document.body, { select: !0 }), o.removeEventListener(Y, m), ue.remove(h);
        }, 0);
      };
    }
  }, [o, v, m, h]);
  const w = u.useCallback(
    (i) => {
      if (!r && !n || h.paused) return;
      const f = i.key === "Tab" && !i.altKey && !i.ctrlKey && !i.metaKey, p = document.activeElement;
      if (f && p) {
        const S = i.currentTarget, [y, b] = qe(S);
        y && b ? !i.shiftKey && p === b ? (i.preventDefault(), r && R(y, { select: !0 })) : i.shiftKey && p === y && (i.preventDefault(), r && R(b, { select: !0 })) : p === S && i.preventDefault();
      }
    },
    [r, n, h.paused]
  );
  return /* @__PURE__ */ E(J.div, { tabIndex: -1, ...s, ref: d, onKeyDown: w });
});
ge.displayName = ze;
function $e(e, { select: t = !1 } = {}) {
  const r = document.activeElement;
  for (const n of e)
    if (R(n, { select: t }), document.activeElement !== r) return;
}
function qe(e) {
  const t = ye(e), r = ce(t, e), n = ce(t.reverse(), e);
  return [r, n];
}
function ye(e) {
  const t = [], r = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (n) => {
      const a = n.tagName === "INPUT" && n.type === "hidden";
      return n.disabled || n.hidden || a ? NodeFilter.FILTER_SKIP : n.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; r.nextNode(); ) t.push(r.currentNode);
  return t;
}
function ce(e, t) {
  for (const r of e)
    if (!Qe(r, { upTo: t })) return r;
}
function Qe(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function Je(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function R(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const r = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== r && Je(e) && t && e.select();
  }
}
var ue = et();
function et() {
  let e = [];
  return {
    add(t) {
      const r = e[0];
      t !== r && (r == null || r.pause()), e = ie(e, t), e.unshift(t);
    },
    remove(t) {
      var r;
      e = ie(e, t), (r = e[0]) == null || r.resume();
    }
  };
}
function ie(e, t) {
  const r = [...e], n = r.indexOf(t);
  return n !== -1 && r.splice(n, 1), r;
}
function tt(e) {
  return e.filter((t) => t.tagName !== "A");
}
var rt = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, k = /* @__PURE__ */ new WeakMap(), D = /* @__PURE__ */ new WeakMap(), W = {}, G = 0, be = function(e) {
  return e && (e.host || be(e.parentNode));
}, nt = function(e, t) {
  return t.map(function(r) {
    if (e.contains(r))
      return r;
    var n = be(r);
    return n && e.contains(n) ? n : (console.error("aria-hidden", r, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(r) {
    return !!r;
  });
}, ot = function(e, t, r, n) {
  var a = nt(t, Array.isArray(e) ? e : [e]);
  W[r] || (W[r] = /* @__PURE__ */ new WeakMap());
  var c = W[r], s = [], o = /* @__PURE__ */ new Set(), g = new Set(a), v = function(l) {
    !l || o.has(l) || (o.add(l), v(l.parentNode));
  };
  a.forEach(v);
  var m = function(l) {
    !l || g.has(l) || Array.prototype.forEach.call(l.children, function(d) {
      if (o.has(d))
        m(d);
      else
        try {
          var h = d.getAttribute(n), w = h !== null && h !== "false", i = (k.get(d) || 0) + 1, f = (c.get(d) || 0) + 1;
          k.set(d, i), c.set(d, f), s.push(d), i === 1 && w && D.set(d, !0), f === 1 && d.setAttribute(r, "true"), w || d.setAttribute(n, "true");
        } catch (p) {
          console.error("aria-hidden: cannot operate on ", d, p);
        }
    });
  };
  return m(t), o.clear(), G++, function() {
    s.forEach(function(l) {
      var d = k.get(l) - 1, h = c.get(l) - 1;
      k.set(l, d), c.set(l, h), d || (D.has(l) || l.removeAttribute(n), D.delete(l)), h || l.removeAttribute(r);
    }), G--, G || (k = /* @__PURE__ */ new WeakMap(), k = /* @__PURE__ */ new WeakMap(), D = /* @__PURE__ */ new WeakMap(), W = {});
  };
}, at = function(e, t, r) {
  r === void 0 && (r = "data-aria-hidden");
  var n = Array.from(Array.isArray(e) ? e : [e]), a = rt(e);
  return a ? (n.push.apply(n, Array.from(a.querySelectorAll("[aria-live]"))), ot(n, a, r, "aria-hidden")) : function() {
    return null;
  };
}, P = function() {
  return P = Object.assign || function(t) {
    for (var r, n = 1, a = arguments.length; n < a; n++) {
      r = arguments[n];
      for (var c in r) Object.prototype.hasOwnProperty.call(r, c) && (t[c] = r[c]);
    }
    return t;
  }, P.apply(this, arguments);
};
function Ee(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
      t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
}
function ct(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, a = t.length, c; n < a; n++)
    (c || !(n in t)) && (c || (c = Array.prototype.slice.call(t, 0, n)), c[n] = t[n]);
  return e.concat(c || Array.prototype.slice.call(t));
}
var H = "right-scroll-bar-position", K = "width-before-scroll-bar", ut = "with-scroll-bars-hidden", it = "--removed-body-scroll-bar-size";
function Z(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function st(e, t) {
  var r = We(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return r.value;
        },
        set current(n) {
          var a = r.value;
          a !== n && (r.value = n, r.callback(n, a));
        }
      }
    };
  })[0];
  return r.callback = t, r.facade;
}
var lt = typeof window < "u" ? u.useLayoutEffect : u.useEffect, se = /* @__PURE__ */ new WeakMap();
function ft(e, t) {
  var r = st(null, function(n) {
    return e.forEach(function(a) {
      return Z(a, n);
    });
  });
  return lt(function() {
    var n = se.get(r);
    if (n) {
      var a = new Set(n), c = new Set(e), s = r.current;
      a.forEach(function(o) {
        c.has(o) || Z(o, null);
      }), c.forEach(function(o) {
        a.has(o) || Z(o, s);
      });
    }
    se.set(r, e);
  }, [e]), r;
}
function dt(e) {
  return e;
}
function vt(e, t) {
  t === void 0 && (t = dt);
  var r = [], n = !1, a = {
    read: function() {
      if (n)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return r.length ? r[r.length - 1] : e;
    },
    useMedium: function(c) {
      var s = t(c, n);
      return r.push(s), function() {
        r = r.filter(function(o) {
          return o !== s;
        });
      };
    },
    assignSyncMedium: function(c) {
      for (n = !0; r.length; ) {
        var s = r;
        r = [], s.forEach(c);
      }
      r = {
        push: function(o) {
          return c(o);
        },
        filter: function() {
          return r;
        }
      };
    },
    assignMedium: function(c) {
      n = !0;
      var s = [];
      if (r.length) {
        var o = r;
        r = [], o.forEach(c), s = r;
      }
      var g = function() {
        var m = s;
        s = [], m.forEach(c);
      }, v = function() {
        return Promise.resolve().then(g);
      };
      v(), r = {
        push: function(m) {
          s.push(m), v();
        },
        filter: function(m) {
          return s = s.filter(m), r;
        }
      };
    }
  };
  return a;
}
function pt(e) {
  e === void 0 && (e = {});
  var t = vt(null);
  return t.options = P({ async: !0, ssr: !1 }, e), t;
}
var Ce = function(e) {
  var t = e.sideCar, r = Ee(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var n = t.read();
  if (!n)
    throw new Error("Sidecar medium not found");
  return u.createElement(n, P({}, r));
};
Ce.isSideCarExport = !0;
function ht(e, t) {
  return e.useMedium(t), Ce;
}
var Se = pt(), z = function() {
}, j = u.forwardRef(function(e, t) {
  var r = u.useRef(null), n = u.useState({
    onScrollCapture: z,
    onWheelCapture: z,
    onTouchMoveCapture: z
  }), a = n[0], c = n[1], s = e.forwardProps, o = e.children, g = e.className, v = e.removeScrollBar, m = e.enabled, l = e.shards, d = e.sideCar, h = e.noIsolation, w = e.inert, i = e.allowPinchZoom, f = e.as, p = f === void 0 ? "div" : f, S = e.gapMode, y = Ee(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), b = d, C = ft([r, t]), O = P(P({}, y), a);
  return u.createElement(
    u.Fragment,
    null,
    m && u.createElement(b, { sideCar: Se, removeScrollBar: v, shards: l, noIsolation: h, inert: w, setCallbacks: c, allowPinchZoom: !!i, lockRef: r, gapMode: S }),
    s ? u.cloneElement(u.Children.only(o), P(P({}, O), { ref: C })) : u.createElement(p, P({}, O, { className: g, ref: C }), o)
  );
});
j.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
j.classNames = {
  fullWidth: K,
  zeroRight: H
};
var mt = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function gt() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = mt();
  return t && e.setAttribute("nonce", t), e;
}
function yt(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function bt(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var Et = function() {
  var e = 0, t = null;
  return {
    add: function(r) {
      e == 0 && (t = gt()) && (yt(t, r), bt(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, Ct = function() {
  var e = Et();
  return function(t, r) {
    u.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && r]);
  };
}, we = function() {
  var e = Ct(), t = function(r) {
    var n = r.styles, a = r.dynamic;
    return e(n, a), null;
  };
  return t;
}, St = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, $ = function(e) {
  return parseInt(e || "", 10) || 0;
}, wt = function(e) {
  var t = window.getComputedStyle(document.body), r = t[e === "padding" ? "paddingLeft" : "marginLeft"], n = t[e === "padding" ? "paddingTop" : "marginTop"], a = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [$(r), $(n), $(a)];
}, Pt = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return St;
  var t = wt(e), r = document.documentElement.clientWidth, n = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, n - r + t[2] - t[0])
  };
}, Rt = we(), x = "data-scroll-locked", At = function(e, t, r, n) {
  var a = e.left, c = e.top, s = e.right, o = e.gap;
  return r === void 0 && (r = "margin"), `
  .`.concat(ut, ` {
   overflow: hidden `).concat(n, `;
   padding-right: `).concat(o, "px ").concat(n, `;
  }
  body[`).concat(x, `] {
    overflow: hidden `).concat(n, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(n, ";"),
    r === "margin" && `
    padding-left: `.concat(a, `px;
    padding-top: `).concat(c, `px;
    padding-right: `).concat(s, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(o, "px ").concat(n, `;
    `),
    r === "padding" && "padding-right: ".concat(o, "px ").concat(n, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(H, ` {
    right: `).concat(o, "px ").concat(n, `;
  }
  
  .`).concat(K, ` {
    margin-right: `).concat(o, "px ").concat(n, `;
  }
  
  .`).concat(H, " .").concat(H, ` {
    right: 0 `).concat(n, `;
  }
  
  .`).concat(K, " .").concat(K, ` {
    margin-right: 0 `).concat(n, `;
  }
  
  body[`).concat(x, `] {
    `).concat(it, ": ").concat(o, `px;
  }
`);
}, le = function() {
  var e = parseInt(document.body.getAttribute(x) || "0", 10);
  return isFinite(e) ? e : 0;
}, Ot = function() {
  u.useEffect(function() {
    return document.body.setAttribute(x, (le() + 1).toString()), function() {
      var e = le() - 1;
      e <= 0 ? document.body.removeAttribute(x) : document.body.setAttribute(x, e.toString());
    };
  }, []);
}, kt = function(e) {
  var t = e.noRelative, r = e.noImportant, n = e.gapMode, a = n === void 0 ? "margin" : n;
  Ot();
  var c = u.useMemo(function() {
    return Pt(a);
  }, [a]);
  return u.createElement(Rt, { styles: At(c, !t, a, r ? "" : "!important") });
}, q = !1;
if (typeof window < "u")
  try {
    var B = Object.defineProperty({}, "passive", {
      get: function() {
        return q = !0, !0;
      }
    });
    window.addEventListener("test", B, B), window.removeEventListener("test", B, B);
  } catch {
    q = !1;
  }
var N = q ? { passive: !1 } : !1, Nt = function(e) {
  return e.tagName === "TEXTAREA";
}, Pe = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var r = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    r[t] !== "hidden" && // contains scroll inside self
    !(r.overflowY === r.overflowX && !Nt(e) && r[t] === "visible")
  );
}, Tt = function(e) {
  return Pe(e, "overflowY");
}, xt = function(e) {
  return Pe(e, "overflowX");
}, fe = function(e, t) {
  var r = t.ownerDocument, n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var a = Re(e, n);
    if (a) {
      var c = Ae(e, n), s = c[1], o = c[2];
      if (s > o)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== r.body);
  return !1;
}, Mt = function(e) {
  var t = e.scrollTop, r = e.scrollHeight, n = e.clientHeight;
  return [
    t,
    r,
    n
  ];
}, Ft = function(e) {
  var t = e.scrollLeft, r = e.scrollWidth, n = e.clientWidth;
  return [
    t,
    r,
    n
  ];
}, Re = function(e, t) {
  return e === "v" ? Tt(t) : xt(t);
}, Ae = function(e, t) {
  return e === "v" ? Mt(t) : Ft(t);
}, _t = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, It = function(e, t, r, n, a) {
  var c = _t(e, window.getComputedStyle(t).direction), s = c * n, o = r.target, g = t.contains(o), v = !1, m = s > 0, l = 0, d = 0;
  do {
    var h = Ae(e, o), w = h[0], i = h[1], f = h[2], p = i - f - c * w;
    (w || p) && Re(e, o) && (l += p, d += w), o instanceof ShadowRoot ? o = o.host : o = o.parentNode;
  } while (
    // portaled content
    !g && o !== document.body || // self content
    g && (t.contains(o) || t === o)
  );
  return (m && Math.abs(l) < 1 || !m && Math.abs(d) < 1) && (v = !0), v;
}, U = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, de = function(e) {
  return [e.deltaX, e.deltaY];
}, ve = function(e) {
  return e && "current" in e ? e.current : e;
}, Lt = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, Dt = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, Wt = 0, T = [];
function Bt(e) {
  var t = u.useRef([]), r = u.useRef([0, 0]), n = u.useRef(), a = u.useState(Wt++)[0], c = u.useState(we)[0], s = u.useRef(e);
  u.useEffect(function() {
    s.current = e;
  }, [e]), u.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(a));
      var i = ct([e.lockRef.current], (e.shards || []).map(ve), !0).filter(Boolean);
      return i.forEach(function(f) {
        return f.classList.add("allow-interactivity-".concat(a));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(a)), i.forEach(function(f) {
          return f.classList.remove("allow-interactivity-".concat(a));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var o = u.useCallback(function(i, f) {
    if ("touches" in i && i.touches.length === 2 || i.type === "wheel" && i.ctrlKey)
      return !s.current.allowPinchZoom;
    var p = U(i), S = r.current, y = "deltaX" in i ? i.deltaX : S[0] - p[0], b = "deltaY" in i ? i.deltaY : S[1] - p[1], C, O = i.target, F = Math.abs(y) > Math.abs(b) ? "h" : "v";
    if ("touches" in i && F === "h" && O.type === "range")
      return !1;
    var L = fe(F, O);
    if (!L)
      return !0;
    if (L ? C = F : (C = F === "v" ? "h" : "v", L = fe(F, O)), !L)
      return !1;
    if (!n.current && "changedTouches" in i && (y || b) && (n.current = C), !C)
      return !0;
    var re = n.current || C;
    return It(re, f, i, re === "h" ? y : b);
  }, []), g = u.useCallback(function(i) {
    var f = i;
    if (!(!T.length || T[T.length - 1] !== c)) {
      var p = "deltaY" in f ? de(f) : U(f), S = t.current.filter(function(C) {
        return C.name === f.type && (C.target === f.target || f.target === C.shadowParent) && Lt(C.delta, p);
      })[0];
      if (S && S.should) {
        f.cancelable && f.preventDefault();
        return;
      }
      if (!S) {
        var y = (s.current.shards || []).map(ve).filter(Boolean).filter(function(C) {
          return C.contains(f.target);
        }), b = y.length > 0 ? o(f, y[0]) : !s.current.noIsolation;
        b && f.cancelable && f.preventDefault();
      }
    }
  }, []), v = u.useCallback(function(i, f, p, S) {
    var y = { name: i, delta: f, target: p, should: S, shadowParent: Ut(p) };
    t.current.push(y), setTimeout(function() {
      t.current = t.current.filter(function(b) {
        return b !== y;
      });
    }, 1);
  }, []), m = u.useCallback(function(i) {
    r.current = U(i), n.current = void 0;
  }, []), l = u.useCallback(function(i) {
    v(i.type, de(i), i.target, o(i, e.lockRef.current));
  }, []), d = u.useCallback(function(i) {
    v(i.type, U(i), i.target, o(i, e.lockRef.current));
  }, []);
  u.useEffect(function() {
    return T.push(c), e.setCallbacks({
      onScrollCapture: l,
      onWheelCapture: l,
      onTouchMoveCapture: d
    }), document.addEventListener("wheel", g, N), document.addEventListener("touchmove", g, N), document.addEventListener("touchstart", m, N), function() {
      T = T.filter(function(i) {
        return i !== c;
      }), document.removeEventListener("wheel", g, N), document.removeEventListener("touchmove", g, N), document.removeEventListener("touchstart", m, N);
    };
  }, []);
  var h = e.removeScrollBar, w = e.inert;
  return u.createElement(
    u.Fragment,
    null,
    w ? u.createElement(c, { styles: Dt(a) }) : null,
    h ? u.createElement(kt, { gapMode: e.gapMode }) : null
  );
}
function Ut(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const Ht = ht(Se, Bt);
var Oe = u.forwardRef(function(e, t) {
  return u.createElement(j, P({}, e, { ref: t, sideCar: Ht }));
});
Oe.classNames = j.classNames;
var ee = "Popover", [ke, cr] = Be(ee, [
  pe
]), I = pe(), [Kt, A] = ke(ee), Ne = (e) => {
  const {
    __scopePopover: t,
    children: r,
    open: n,
    defaultOpen: a,
    onOpenChange: c,
    modal: s = !1
  } = e, o = I(t), g = u.useRef(null), [v, m] = u.useState(!1), [l = !1, d] = Ue({
    prop: n,
    defaultProp: a,
    onChange: c
  });
  return /* @__PURE__ */ E(Ve, { ...o, children: /* @__PURE__ */ E(
    Kt,
    {
      scope: t,
      contentId: Ye(),
      triggerRef: g,
      open: l,
      onOpenChange: d,
      onOpenToggle: u.useCallback(() => d((h) => !h), [d]),
      hasCustomAnchor: v,
      onCustomAnchorAdd: u.useCallback(() => m(!0), []),
      onCustomAnchorRemove: u.useCallback(() => m(!1), []),
      modal: s,
      children: r
    }
  ) });
};
Ne.displayName = ee;
var Te = "PopoverAnchor", jt = u.forwardRef(
  (e, t) => {
    const { __scopePopover: r, ...n } = e, a = A(Te, r), c = I(r), { onCustomAnchorAdd: s, onCustomAnchorRemove: o } = a;
    return u.useEffect(() => (s(), () => o()), [s, o]), /* @__PURE__ */ E(he, { ...c, ...n, ref: t });
  }
);
jt.displayName = Te;
var xe = "PopoverTrigger", Me = u.forwardRef(
  (e, t) => {
    const { __scopePopover: r, ...n } = e, a = A(xe, r), c = I(r), s = Q(t, a.triggerRef), o = /* @__PURE__ */ E(
      J.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": a.open,
        "aria-controls": a.contentId,
        "data-state": De(a.open),
        ...n,
        ref: s,
        onClick: _(e.onClick, a.onOpenToggle)
      }
    );
    return a.hasCustomAnchor ? o : /* @__PURE__ */ E(he, { asChild: !0, ...c, children: o });
  }
);
Me.displayName = xe;
var te = "PopoverPortal", [Vt, Xt] = ke(te, {
  forceMount: void 0
}), Fe = (e) => {
  const { __scopePopover: t, forceMount: r, children: n, container: a } = e, c = A(te, t);
  return /* @__PURE__ */ E(Vt, { scope: t, forceMount: r, children: /* @__PURE__ */ E(me, { present: r || c.open, children: /* @__PURE__ */ E(Xe, { asChild: !0, container: a, children: n }) }) });
};
Fe.displayName = te;
var M = "PopoverContent", _e = u.forwardRef(
  (e, t) => {
    const r = Xt(M, e.__scopePopover), { forceMount: n = r.forceMount, ...a } = e, c = A(M, e.__scopePopover);
    return /* @__PURE__ */ E(me, { present: n || c.open, children: c.modal ? /* @__PURE__ */ E(Yt, { ...a, ref: t }) : /* @__PURE__ */ E(Gt, { ...a, ref: t }) });
  }
);
_e.displayName = M;
var Yt = u.forwardRef(
  (e, t) => {
    const r = A(M, e.__scopePopover), n = u.useRef(null), a = Q(t, n), c = u.useRef(!1);
    return u.useEffect(() => {
      const s = n.current;
      if (s) return at(s);
    }, []), /* @__PURE__ */ E(Oe, { as: Ge, allowPinchZoom: !0, children: /* @__PURE__ */ E(
      Ie,
      {
        ...e,
        ref: a,
        trapFocus: r.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: _(e.onCloseAutoFocus, (s) => {
          var o;
          s.preventDefault(), c.current || (o = r.triggerRef.current) == null || o.focus();
        }),
        onPointerDownOutside: _(
          e.onPointerDownOutside,
          (s) => {
            const o = s.detail.originalEvent, g = o.button === 0 && o.ctrlKey === !0, v = o.button === 2 || g;
            c.current = v;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: _(
          e.onFocusOutside,
          (s) => s.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), Gt = u.forwardRef(
  (e, t) => {
    const r = A(M, e.__scopePopover), n = u.useRef(!1), a = u.useRef(!1);
    return /* @__PURE__ */ E(
      Ie,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (c) => {
          var s, o;
          (s = e.onCloseAutoFocus) == null || s.call(e, c), c.defaultPrevented || (n.current || (o = r.triggerRef.current) == null || o.focus(), c.preventDefault()), n.current = !1, a.current = !1;
        },
        onInteractOutside: (c) => {
          var g, v;
          (g = e.onInteractOutside) == null || g.call(e, c), c.defaultPrevented || (n.current = !0, c.detail.originalEvent.type === "pointerdown" && (a.current = !0));
          const s = c.target;
          ((v = r.triggerRef.current) == null ? void 0 : v.contains(s)) && c.preventDefault(), c.detail.originalEvent.type === "focusin" && a.current && c.preventDefault();
        }
      }
    );
  }
), Ie = u.forwardRef(
  (e, t) => {
    const {
      __scopePopover: r,
      trapFocus: n,
      onOpenAutoFocus: a,
      onCloseAutoFocus: c,
      disableOutsidePointerEvents: s,
      onEscapeKeyDown: o,
      onPointerDownOutside: g,
      onFocusOutside: v,
      onInteractOutside: m,
      ...l
    } = e, d = A(M, r), h = I(r);
    return Ze(), /* @__PURE__ */ E(
      ge,
      {
        asChild: !0,
        loop: !0,
        trapped: n,
        onMountAutoFocus: a,
        onUnmountAutoFocus: c,
        children: /* @__PURE__ */ E(
          He,
          {
            asChild: !0,
            disableOutsidePointerEvents: s,
            onInteractOutside: m,
            onEscapeKeyDown: o,
            onPointerDownOutside: g,
            onFocusOutside: v,
            onDismiss: () => d.onOpenChange(!1),
            children: /* @__PURE__ */ E(
              Ke,
              {
                "data-state": De(d.open),
                role: "dialog",
                id: d.contentId,
                ...h,
                ...l,
                ref: t,
                style: {
                  ...l.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), Le = "PopoverClose", Zt = u.forwardRef(
  (e, t) => {
    const { __scopePopover: r, ...n } = e, a = A(Le, r);
    return /* @__PURE__ */ E(
      J.button,
      {
        type: "button",
        ...n,
        ref: t,
        onClick: _(e.onClick, () => a.onOpenChange(!1))
      }
    );
  }
);
Zt.displayName = Le;
var zt = "PopoverArrow", $t = u.forwardRef(
  (e, t) => {
    const { __scopePopover: r, ...n } = e, a = I(r);
    return /* @__PURE__ */ E(je, { ...a, ...n, ref: t });
  }
);
$t.displayName = zt;
function De(e) {
  return e ? "open" : "closed";
}
var ur = Ne, ir = Me, sr = Fe, lr = _e;
export {
  lr as C,
  sr as P,
  ur as R,
  ir as T,
  Oe as a,
  at as h,
  Ze as u
};
